import i18n from "i18next";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const errorResolver = (error: any) => {
  if (error.request) {
    return error?.request?.message ?? i18n.t("errors.server-unable");
  }

  if (error.error) {
    return error?.error ?? i18n.t("errors.server-unable");
  }

  if (error) {
    return error?.result ?? i18n.t("errors.server-unable");
  }

  return error?.message ?? i18n.t("errors.server-unable");
};

export const ExceptionService = {
  errorResolver,
};
